<template>
  <item-block class="cy-whitches-sockets-serie-selector">
    <base-subheader><span v-t="'Choose switches & sockets serie'" /></base-subheader>

    <v-radio-group :disabled="$store.getters.isDisabled" v-model="selectedSlug">
      <v-radio v-for="socket in options" :key="'option-' + socket.slug" :value="socket.slug">
        <template #label>
          {{ socket.title }}

          <v-chip
            class="ml-5"
            v-bind="{ color: 'blue-grey darken-2' }"
            dark
            v-if="_.has(socket, ['price', $store.getters.apartment.rooms + '-rooms'])"
          >
            {{ _.get(socket, ["price", $store.getters.apartment.rooms + "-rooms"]) }} €
          </v-chip>
          <!-- <small
            class="mx-1"
            v-if="_.has(socket, ['price', $store.getters.apartment.rooms + '-rooms'])"
          >
            {{
              $t("(extra cost: {0} €)", [
                _.get(socket, ["price", $store.getters.apartment.rooms + "-rooms"]),
              ])
            }}
          </small> -->
        </template>
      </v-radio>
    </v-radio-group>

    <div :key="serie.slug" v-for="serie in options" v-show="serie.slug === selectedSlug">
      <v-icon left>mdi-check</v-icon>
      <span class="text-h6" v-text="serie.title" />
      <v-sheet v-if="serie.images && serie.images.length > 0" height="270">
        <div class="d-flex">
          <div class="pa-3" v-for="(src, i) in serie.images" :key="'standard-' + i">
            <v-sheet width="240">
              <v-img width="240" :src="src"></v-img>
            </v-sheet>
          </div>
        </div>
        <div>
          <v-subheader style="height: 24px !important" class="pb-5">
            {{ serie.subtitle }}
          </v-subheader>
        </div>
      </v-sheet>
    </div>
  </item-block>
</template>

<script>
export default {
  computed: {
    selectedSlug: {
      get() {
        return this.$store.state.preferences.switch_socket_serie_slug;
      },
      set(value) {
        this.$store.dispatch("setPreference", { switch_socket_serie_slug: value });
      },
    },
    selectedSerie() {
      return this.options.find((item) => item.slug === this.selectedSlug);
    },
    options() {
      return this.$store.state.options.switch_socket_series;
    },
  },
};
</script>
